<template>
	<transition name="el-fade-in">
		<div class="page-component-up" @click="scrollToTop" v-show="toTopShow">
			<i class="icon-btn-backtotop"></i>
		</div>
	</transition>
</template>
<script>
export default {
  data () {
    return {
      toTopShow: false
    }
  },
  methods: {
    handleScroll () {
      if (process.browser) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.toTopShow = this.scrollTop > 300
      }
    },
    scrollToTop () {
      let timer = null
      let _this = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn () {
        if (_this.scrollTop > 0) {
          _this.scrollTop -= 50
          document.documentElement.scrollTop = document.body.scrollTop = _this.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _this.toTopShow = false
        }
      })
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('scroll', this.handleScroll)
    })
  },
  destoryed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped lang="less">
  .page-component-up{
    width: 54px;
    height: 54px;
    border-radius: 5px;
    background-color: #ffc900;
    position: fixed;
    bottom: 100px;
    right: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    .icon-btn-backtotop{
      display: block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PageScroll/ScrollToTop.vue